import { render, staticRenderFns } from "./add-subject.vue?vue&type=template&id=2a0bf8f0"
import script from "./add-subject.vue?vue&type=script&lang=js"
export * from "./add-subject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports